const CONFIG = {

    BASE_URL: 'https://www.tresatec.com.ar/',  //Localhost
    API_URL:'https://www.tresatec.com.ar/Api', //Localhost
    //BASE_URL: 'http://localhost:3000/',  //Localhost
    //API_URL:'http://localhost/tresatec/proyect/proyect/src/Api/', //Localhost
   // BASE_URL: 'http://172.16.103.7:3000/',  //IP polo
   // API_URL: 'http://172.16.103.7/tresatec/BOC/src/API', //IP polo
    //BASE_URL: 'http://25.38.52.197:3000/',  //IP hamachi
    //API_URL: 'http://25.38.52.197/tresatec/BOC/src/API', //IP hamchi

};

export default CONFIG;